import { AxiosResponse } from "axios";
import { request } from "../../../utils";
import { ILogin } from "../../../types";

export const loginPostApi = (
  email: string,
  password: string,
): Promise<AxiosResponse<ILogin>> => {
  const req = request();
  return req.post(`/api/v1/login`, {
    email: `${email}`,
    password: `${password}`,
  });
};
